<template>

    <transition name="fade-scale">

        <div class="brt-loading"  v-if="visible">

            <div class="wrap">

                <i class="iconfont icon-jiazai1"></i>
                <span>{{content}}</span>
            </div>


        </div>

    </transition>
</template>

<script>
    export default {
        name: "loading",
        data(){
            return {
                visible:false,
                content:'请稍等',
                timeout:10,
                callback:'',
            }
        }
    }
</script>

<style lang="less">

    @import "../../styles/cssBlock.less";
    @import "../../styles/transition.less";

    .brt-loading{
        .fixedByCover();
        .flexCenter();
        flex-direction: column;
        background-color: fade(#333333,50%);
        color: white;
        z-index: 90000;

        >.wrap{
            .flexCenter();
            flex-direction: column;

            @keyframes loading
            {
                from {transform: rotate(0deg)}
                to {transform: rotate(360deg)}
            }

            >i{
                color: @themeReverseColor;
                font-size: @80px;
                animation: loading 1s linear infinite;
            }

            >span{
                margin-top: @standartSpaceA1;
                white-space: nowrap;
                font-size: @normalFontSize;
            }
        }
    }
</style>
